import { render, staticRenderFns } from "./DataTableActionSelectorNew.vue?vue&type=template&id=5b874fb1"
import script from "./DataTableActionSelectorNew.vue?vue&type=script&lang=js"
export * from "./DataTableActionSelectorNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports